import { ReactNode } from 'react';
import { Box } from '@spark-web/box';
import { Text } from '@spark-web/text';
import { Step } from '@spark-web/vertical-stepper';
import { APPLICATION_UNDER_REVIEW } from '../../utils';

type ApplicationUnderReviewStepProps = {
  readonly customerPortalCard?: ReactNode;
};

function ApplicationUnderReviewStep({ customerPortalCard }: ApplicationUnderReviewStepProps) {
  return (
    <Step>
      <Step.Heading title={APPLICATION_UNDER_REVIEW.TITLE} renderStepNumber={() => ''} />
      <Step.Content>
        {/* Step.Content, not Step.Description: Spark only renders Content for the active step,
            and this copy must not show while the joint applicant step is active instead. */}
        <Box paddingBottom="large">
          <Text size="standard">{APPLICATION_UNDER_REVIEW.CONTENT}</Text>
        </Box>
        {customerPortalCard}
      </Step.Content>
    </Step>
  );
}

export default ApplicationUnderReviewStep;
